<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Personal</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="personalform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Name" rules="required">
                                                <v-text-field
                                                v-model="form.name"
                                                :error-messages="errors"
                                                label="Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                                                <v-text-field
                                                v-model="form.email"
                                                :error-messages="errors"
                                                label="E-mail"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Phone">
                                                <v-text-field
                                                v-model="form.phone"
                                                :error-messages="errors"
                                                label="Phone"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Role" rules="required">
                                                <v-select
                                                    v-model="form.role"
                                                    :items="roles"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="User Role"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                           <ValidationProvider v-slot="{ errors }" name="Password" vid="password">
                                                <v-text-field
                                                    ref="password"
                                                    type="password"
                                                    v-model="form.password"
                                                    :error-messages="errors"
                                                    label="Password"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Confirm Password" rules="confirmed:password">
                                                <v-text-field
                                                    ref="password_confirmation"
                                                    type="password"
                                                    v-model="form.password_confirmation"
                                                    :error-messages="errors"
                                                    label="Confirm Password"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="4 Digit Code" rules="max:4">
                                                <v-text-field
                                                    ref="logincode"
                                                    type="logincode"
                                                    v-model="form.logincode"
                                                    :error-messages="errors"
                                                    label="Login Code"
                                                ></v-text-field>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>            
                        <v-btn large min-width="50%" color="blue darken-1" text to="/dashboard">Cancel</v-btn>            
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Update</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, max } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

extend('max', {
    ...max,
    message: '{_field_} must limit to 4 digits',
})


export default {
    props: ['id'],
    data () {
        return {
            tab: null,
            form: {
                name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                logincode: '',
                role: '',

            },
            loading: false,
            comment: {
                comment: '',
                public: false,
                parent: null,
                type: 'comment'
            },
        }
    },
    created() {
        this.getUser()
    },
    computed: {
        ...mapGetters({
            roles: 'data/roles'
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        getUser() {
            if(this.id) {
                axios.get('crm/users/get?id=' + this.id)
                    .then((response) => {
                        this.form.name = response.data.name
                        this.form.phone = response.data.phone
                        this.form.email = response.data.email
                        this.form.role = response.data.roles[0].name
                        this.$nextTick()
                    })
            }
        },
        ...mapActions({
            updateUser: 'data/updateUser',
            addComment: 'data/addComment'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateUser(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: '/users' })
                }).catch(error => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
    }
}
</script>

<style lang="sass">
.theme--light
    &.status
        background: #e0f2f5
</style>